import { ReactNode, useEffect } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { useLocation } from "wouter";
import { Breadcrumbs } from "@/components/CrawlLinks";

interface LayoutProps {
  children: ReactNode;
}

function ScrollToTop() {
  const [location] = useLocation();
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const id = hash.slice(1);
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      };
      tryScroll();
      const timer = setTimeout(tryScroll, 150);
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [location]);
  return null;
}

export function Layout({ children }: LayoutProps) {
  const [location] = useLocation();

  return (
    <div className="flex flex-col min-h-screen">
      <ScrollToTop />
      <Header />
      <main
        className="flex-grow"
        style={{
          paddingTop:
            location === "/"
              ? "var(--safe-area-main-pt)"
              : "calc(env(safe-area-inset-top, 0px) + 10rem)",
        }}
      >
        {location !== "/" && <Breadcrumbs path={location} />}
        {children}
      </main>
      <Footer />
    </div>
  );
}
